import React, { useContext } from 'react';
import { Button } from 'primereact/button';
import { ScrollPanel } from 'primereact/scrollpanel';       
import { ToolsContext, ToolsDispatchContext } from '../ToolsContext.js';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useQueryGtfsResourceById } from '../Queries.js';
import { DataContext } from '../DataContext.js';

export function PropertyEditor({ resourceTable, selectedItemId, header, errorText, children }) {
    const { isPending, error, data, dataUpdatedAt } = useQueryGtfsResourceById(resourceTable,selectedItemId);
    const tool = useContext(ToolsContext);
    const dispatch = useContext(ToolsDispatchContext);

    function handleExit() {
        dispatch({
            type: 'changed',
            newTool: {
                ...tool,
                propertyEditor: null,  // wyczyść edytor (spowoduje jego ukrycie)
                selection: null  // odznacz zasób
            }
        });
        return true;
    }

    if (isPending || !data) {
        return (
            <ProgressSpinner className="flex justify-content-center"/>
        );
    }

    if (error) {
        return (
            <>
                <i className="fa-solid fa-face-frown fa-5x"></i><br />
                {errorText} {error.message}
            </>
        )
    }


    return (
        <div className='p-3 relative w-full' key={String(selectedItemId)}>
            <Button icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" className='absolute top-0 right-0' onClick={handleExit} />
            <div style={{maxWidth: '30vw'}} className='pb-3 white-space-nowrap overflow-hidden text-overflow-ellipsis'>
                <i className="fa-solid fa-pen-to-square mr-2"></i>
                    {header}
            </div>
            <ScrollPanel style={{width: '100%', height: '80vh'}}>
                <DataContext.Provider value={{inputValues: data, dataUpdatedAt: dataUpdatedAt}}>
                    {children}  
                </DataContext.Provider>
            </ScrollPanel>
        </div>
    )
}